import * as braintree from 'braintree-web'

import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const savePayPalExpressCheckoutBillingAddress: CheckoutActionCreator = ({
  line1,
  line2,
  city,
  state,
  postalCode,
}: braintree.PayPalTokenizePayload['details']['billingAddress']) => ({
  type: actionTypes.SAVE_PAYPAL_EXPRESS_CHECKOUT_BILLING_ADDRESS,
  billingAddress: {
    name: 'My Address',
    line1,
    line2,
    town: city,
    county: state,
    postcode: postalCode,
  },
})
